import { Box, Button, Chip, Stack, Typography } from '@mui/joy';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import { SummaryCards } from './Workspace';
import { formatRating } from '../../utils/rating';

export default function PerformerOverview({ employee, onEdit, onEvents, onReviews }) {
  const stats = employee.surveyor_stats;
  const roleNames = {
    surveyor: 'Обмерщик',
    draftsman: 'Чертёжник',
    manager: 'Менеджер',
    quality_master: 'Мастер качества',
  };
  return (
    <Stack gap={2.5}>
      <SummaryCards
        items={[
          {
            label: 'Рейтинг',
            value: formatRating(employee.rating ?? stats?.rating),
            hint: `Отзывов: ${employee.reviews_count ?? stats?.reviews_count ?? 0}`,
            icon: <StarRoundedIcon />,
            tone: 'warning',
          },
          {
            label: stats ? 'Завершённых обмеров' : 'Событий всего',
            value: stats?.completed_count ?? employee.events_count ?? '—',
            icon: <TaskAltRoundedIcon />,
          },
          {
            label: employee.position?.includes('surveyor') ? 'Зон покрытия' : 'Программ',
            value: employee.position?.includes('surveyor')
              ? (employee.coverage_zones_count ?? '—')
              : (employee.drawing_programs?.length ?? 0),
            icon: <PlaceRoundedIcon />,
          },
        ]}
      />
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1.2fr 1fr' }, gap: 2 }}>
        <Box className="studio-panel" sx={{ p: 2.5 }}>
          <Typography level="title-md" sx={{ mb: 1 }}>
            Контактные данные
          </Typography>
          {[
            [
              <PhoneRoundedIcon />,
              employee.phone,
              employee.phone ? `tel:${employee.phone.replace(/[^+\d]/g, '')}` : null,
            ],
            [<MailOutlineRoundedIcon />, employee.email, employee.email ? `mailto:${employee.email}` : null],
            [<PlaceRoundedIcon />, employee.city_bitrix_name || employee.city],
          ].map(([icon, value, href], i) => (
            <Stack
              key={i}
              direction="row"
              alignItems="center"
              gap={1.5}
              sx={{ py: 1.25, color: 'text.secondary' }}
            >
              {icon}
              {href ? (
                <a className="studio-link" style={{ fontSize: 14 }} href={href}>
                  {value}
                </a>
              ) : (
                <Typography level="body-sm">{value || 'Не указано'}</Typography>
              )}
            </Stack>
          ))}
        </Box>
        <Box className="studio-panel" sx={{ p: 2.5 }}>
          <Typography level="title-md" sx={{ mb: 1.5 }}>
            Рабочая информация
          </Typography>
          <Stack direction="row" gap={0.75} flexWrap="wrap">
            {(employee.position || []).map((p) => (
              <Chip key={p} size="sm" variant="soft">
                {roleNames[p] || p}
              </Chip>
            ))}
          </Stack>
          <Typography level="body-sm" sx={{ mt: 2, color: 'text.tertiary' }}>
            Программы
          </Typography>
          <Stack direction="row" gap={0.75} flexWrap="wrap" sx={{ mt: 0.75 }}>
            {employee.drawing_programs?.length ? (
              employee.drawing_programs.map((p) => (
                <Chip key={p.id} size="sm" variant="soft" color="neutral">
                  {p.name}
                </Chip>
              ))
            ) : (
              <Typography level="body-sm">Не указаны</Typography>
            )}
          </Stack>
          <Typography level="body-sm" sx={{ mt: 2, color: 'text.tertiary' }}>
            Push-уведомления: {employee.has_push ? 'включены' : 'выключены'}
          </Typography>
        </Box>
      </Box>
      <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="flex-end">
        {onEvents && (
          <Button variant="outlined" color="neutral" onClick={onEvents}>
            События исполнителя
          </Button>
        )}
        {onReviews && (
          <Button variant="outlined" color="neutral" onClick={onReviews}>
            Отзывы и оценки
          </Button>
        )}
        <Button onClick={onEdit}>Редактировать данные</Button>
      </Stack>
    </Stack>
  );
}
